export default {
  "content": "<path fill=\"#707070\" d=\"M3.25 0h22.745c1.803 0 3.25 1.496 3.25 3.361V20.17c0 1.865-1.447 3.361-3.25 3.361H3.249C1.446 23.53 0 22.034 0 20.169l.01-10.085h22.736V6.723H.013L.016 3.36C.016 1.496 1.446 0 3.25 0z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "30",
    "height": "24",
    "fill": "none",
    "viewBox": "0 0 30 24"
  }
};